import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service';
import messages, { PaymentTypeMessages } from './messages';

export const REFUND_METHODS = 'refundMethods';

export default {
  id: REFUND_METHODS,
  type: OptionFormTypes.TYPE_IS_RADIO_OPTIONS,
  filterValue: REFUND_METHODS,
  displayName: (appliedFilters) => {
    const paymentTypeFilters = appliedFilters.filter((filter) => filter.filterById === REFUND_METHODS);
    if (paymentTypeFilters.length === 0) {
      return <FormattedMessage {...messages.paymentType} />;
    }

    const paymentTypeKey = paymentTypeFilters[0].criterionArgumentValue;
    return <FormattedMessage {...PaymentTypeMessages[paymentTypeKey]} />;
  },
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations);
  },
};
